module.exports = __webpack_public_path__ + "img/logo.a75eb0a7.png";